import React from 'react'
import RoznicaCITRZiSExpandableRowStyle from '../../styles/RoznicaCITRZiSExpandableRowStyle'
import RoznicaCITRZiSRow from './RoznicaCITRZiSRow'
import InformacjaUzytkownika from './InformacjaUzytkownika'

function RoznicaCITRZiSExpandableRow(props) {
  function przygotujWartosci(value, index, name) {
    const getTarget = () => {
      const target = { name: '', value: 0 }
      if (name.includes('KwotaRP')) {
        target.name = 'KwotaRP_Inne'
        if (name.includes('Kapitalowe')) target.value = props.kwotaRP - value
        else target.value = value - props.kwotaRP_Kapitalowe
      } else if (name.includes('KwotaRB')) {
        target.name = 'KwotaRB_Inne'
        if (name.includes('Kapitalowe')) target.value = props.kwotaRB - value
        else target.value = value - props.kwotaRB_Kapitalowe
      }
      return target
    }
    const target = getTarget()
    props.aktualizujSumy(value, index, name)
    props.aktualizujSumy(target.value, index, target.name)
  }

  function dodajInformacjeUzytkownika() {
    let pozycje = [...props.pozycjeUzytkownika]
    pozycje.push({
      Nazwa: '',
      KwotaRB: 0,
      KwotaRB_Kapitalowe: 0,
      KwotaRB_Inne: 0,
      KwotaRP: 0,
      KwotaRP_Kapitalowe: 0,
      KwotaRP_Inne: 0,
      Art: '',
      Ust: '',
      Pkt: '',
      Lit: '',
    })
    props.onSetSectionDataArray(pozycje, props.index, 'PozycjeUzytkownika')
  }

  function zmienInformacjeUzytkownika(index, e) {
    let pozycje = [...props.pozycjeUzytkownika]
    pozycje[index][e.target.name] = e.target.value
    props.onSetSectionDataArray(pozycje, props.index, 'PozycjeUzytkownika')
  }

  function usunInformacjeUzytkownika(i) {
    let pozycje = [...props.pozycjeUzytkownika]
    pozycje.splice(i, 1)
    props.onSetSectionDataArray(pozycje, props.index, 'PozycjeUzytkownika')
  }

  return (
    <>
      <RoznicaCITRZiSExpandableRowStyle
        className={props.isExpanded ? 'expanded' : ''}
      >
        <RoznicaCITRZiSRow
          index={props.index}
          aktualizujSumy={przygotujWartosci}
          opis={props.opis}
          kwotaRP={props.kwotaRP}
          kwotaRB={props.kwotaRB}
          nameA="KwotaRP"
          nameB="KwotaRB"
          czyKwotyWTysiacach={props.czyKwotyWTysiacach}
        />
        {props.isExpanded ? (
          <div className="content">
            <div className="content-header">
              <p>W TYM:</p>
            </div>
            <RoznicaCITRZiSRow
              index={props.index}
              aktualizujSumy={przygotujWartosci}
              opis="- z zysków kapitałowych"
              kwotaRP={props.kwotaRP_Kapitalowe}
              kwotaRB={props.kwotaRB_Kapitalowe}
              nameA="KwotaRP_Kapitalowe"
              nameB="KwotaRB_Kapitalowe"
              czyKwotyWTysiacach={props.czyKwotyWTysiacach}
            />
            <RoznicaCITRZiSRow
              opis="- z innych źródeł przychodów"
              kwotaRP={props.kwotaRP_Inne}
              kwotaRB={props.kwotaRB_Inne}
              nameA="KwotaRP_Inne"
              nameB="KwotaRB_Inne"
              readOnly={true}
              czyKwotyWTysiacach={props.czyKwotyWTysiacach}
            />
            {props.uszczegolawialne && props.isDetailsVisible && (
              <InformacjaUzytkownika
                dodaj={dodajInformacjeUzytkownika}
                usun={usunInformacjeUzytkownika}
                zmien={zmienInformacjeUzytkownika}
                elements={props.pozycjeUzytkownika}
                czyKwotyWTysiacach={props.czyKwotyWTysiacach}
              />
            )}
          </div>
        ) : null}
      </RoznicaCITRZiSExpandableRowStyle>
    </>
  )
}

export default RoznicaCITRZiSExpandableRow
